<div class="container text-left">
  <p class="pt-3 mt-5"></p>
  <div class="row">
    <div class="col-12 py-2">
      <div class="col-12 p-2">
        <div class="card p-5">
          <div class="card-block bg-faded text-center">
            <h3 class="text-center pb-4">Two Rules</h3>
            <p class="card-text">
              When investing or trading some degree of risk is always involved.
              However, there are ways to minimize that risk, depending on the
              type of investment vehicle/style.
            </p>
            <img
              src="../../assets/img/digital-money-bitcoin-icon-31.png"
              width="150px"
              class="pb-3"
              alt="coin"
            />
            <p class="card-text">
              There are some general rules like this. Two prominent ones that
              apply accross the board. These are:
              <strong>Know what you invest in</strong> and
              <strong>Don't invest more than what you can afford to lose</strong
              >.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 p-2">
        <div class="card p-5">
          <div class="card-block bg-faded">
            <h3 class="text-center pb-4">Knowledge</h3>
            <p class="card-text">
              In considering an investment one should do adequate research to
              understand its basics. Deep knowledge of the inner workings at
              play is not neccessary, but a basic understanding of how the money
              is made is enough. Basically, you should do enough research until
              you are satisfied to take the next step.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 p-2">
        <div class="card p-5">
          <div class="card-block bg-faded text-center">
            <h3 class="text-center pb-4">News Aritcles</h3>
            <div class="row justify-content-center">
              <div class="col-md-3 pb-2">
                <div class="py-2">
                  <img
                    src="../../assets/img/nasdaq-logo.jpg"
                    alt=""
                    class="img-circle"
                    height="100"
                    width="100"
                  />
                </div>
                <a
                  href="http://www.nasdaq.com/article/meet-the-trader-whos-been-using-ai-on-wall-street-since-the-80s-cm834516"
                >
                  #Nasdaq: AI in finance</a
                >
              </div>
              <div class="col-md-3 pb-2">
                <div class="py-2">
                  <img
                    src="../../assets/img/business-insider_logo.jpg"
                    alt=""
                    class="img-circle"
                    height="100"
                    width="100"
                  />
                </div>
                <a
                  href="http://www.businessinsider.com/jpmorgan-takes-ai-use-to-the-next-level-2017-8"
                >
                  #Business Insider: Investment banks and AI</a
                >
              </div>
              <div class="col-md-3 pb-2">
                <div class="py-2">
                  <img
                    src="../../assets/img/business-insider_logo.jpg"
                    alt=""
                    class="img-circle"
                    height="100"
                    width="100"
                  />
                </div>
                <a
                  href="http://www.businessinsider.com/bitcoin-price-surge-leads-to-growth-in-hedge-funds-2017-8"
                >
                  #Business Insider: Companies trading cryptocurrencies</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center"></div>
      <div class="col-12 p-2">
        <div class="card p-5">
          <div class="card-block bg-faded text-center">
            <h3 class="text-center pb-4">Manage Risk</h3>
            <p class="card-text">
              For investments and trading, we can define risk as the amount of
              funds that could potentially be lost by things going against us in
              the market. Therefore, it is generally prudent to not put up more
              money than what you are willing to lose. Don't be in a hurry to
              bet the farm, because there could be something you are unaware of
              at some point, like bad news affecting the market you invested in.
              Though, if you never risk anything you will never enjoy the
              associated rewards either.
            </p>
            <p class="card-text">
              After having done your research and assessing your own finances,
              decide if things go completely wrong, x is the amount I would be
              willing to lose. At a later stage one can reasses with increased
              experience, knowledge and funds.
            </p>
          </div>
        </div>
      </div>

      <hr class="pt-3" />
    </div>
  </div>
</div>
